import { ESTOQUE_BACKEND_URL } from "../settings";
import { api } from "./api";

class BatchService {
  constructor() {
    this.url = ESTOQUE_BACKEND_URL;
  }

  async getBatches({
    page,
    status,
    stage,
    excludeStatus,
    receiptDateFrom,
    receiptDateTo,
    search,
    receiptDate,
    id,
    pageSize,
    purchaseItemReasonId,
    signal,
    ...rest
  }) {
    const url = `${this.url}/api/blueberry/v1/warehouse/batch`;
    return await api.get(url, {
      params: {
        status,
        stage,
        excludeStatus,
        receiptDateFrom,
        receiptDateTo,
        search,
        receiptDate,
        page,
        id,
        pageSize,
        purchaseItemReasonId,
        ...rest
      },
      signal
    });
  }

  async getSellerBatches({
    page,
    status,
    stage,
    excludeStatus,
    receiptDateFrom,
    receiptDateTo,
    search,
    id,
    pageSize,
    purchaseItemReasonId,
    signal
  }) {
    const url = `${this.url}/api/blueberry/v1/warehouse/batch/seller`;
    return await api.get(url, {
      params: {
        status,
        stage,
        excludeStatus,
        receiptDateFrom,
        receiptDateTo,
        search,
        page,
        id,
        pageSize,
        purchaseItemReasonId
      },
      signal
    });
  }

  async getBatchDetail(batchId) {
    const url = `${this.url}/api/blueberry/v1/warehouse/batch/${batchId}`;
    return await api.get(url);
  }

  async createBatchReturn(data) {
    const url = `${this.url}/api/blueberry/v1/warehouse/batch/return`;

    return await api.post(url, data);
  }

  async patchBatchReturn({ id, data }) {
    const url = `${this.url}/api/blueberry/v1/warehouse/batch/return/${id}`;

    return await api.patch(url, data);
  }

  async deleteBatchReturn(id) {
    const url = `${this.url}/api/blueberry/v1/warehouse/batch/return/${id}`;

    return await api.delete(url);
  }

  async newShipment(data) {
    const url = `${this.url}/api/blueberry/v1/warehouse/batch/shipment`;
    return await api.post(url, data);
  }

  async resetBatchReturn(id) {
    const url = `${this.url}/api/blueberry/v1/warehouse/batch/return/${id}/reset`;
    return await api.post(url);
  }

  async createBatchPhysicalReturn(data) {
    const url = `${this.url}/api/blueberry/v1/warehouse/batch/physical-return`;

    return await api.post(url, data);
  }

  async getBatchesReturn({
    page,
    statusId,
    stageId,
    excludeStatus,
    receiptDateFrom,
    receiptDateTo,
    search,
    id,
    pageSize,
    purchaseItemReasonId,
    alignmentDateFrom,
    alignmentDateTo,
    signal
  }) {
    const url = `${this.url}/api/blueberry/v1/warehouse/batch/return`;
    return await api.get(url, {
      params: {
        statusId,
        stageId,
        excludeStatus,
        receiptDateFrom,
        receiptDateTo,
        search,
        page,
        id,
        pageSize,
        purchaseItemReasonId,
        alignmentDateFrom,
        alignmentDateTo
      },
      signal
    });
  }

  async getBatchesV2({
    page,
    status,
    stage,
    refusalInstructionsId,
    excludeStatus,
    receiptDateFrom,
    receiptDateTo,
    receiptDate,
    search,
    id,
    pageSize,
    purchaseItemReasonId,
    isSelection,
    hasAvailableQuantity,
    orderBy,
    signal,
    isStored
  }) {
    const url = `${this.url}/api/blueberry/v1/warehouse/batch/v2`;
    return await api.get(url, {
      params: {
        status,
        stage,
        refusalInstructionsId,
        excludeStatus,
        receiptDateFrom,
        receiptDateTo,
        receiptDate,
        search,
        page,
        id,
        pageSize,
        purchaseItemReasonId,
        orderBy,
        isSelection,
        hasAvailableQuantity,
        isStored
      },
      signal
    });
  }

  async receiptBatchV2(id, data) {
    const url = `${this.url}/api/blueberry/v1/warehouse/batch/v2/${id}/receipt`;
    return await api.patch(url, data);
  }

  async confirmEntryV2(id, data) {
    const url = `${this.url}/api/blueberry/v1/warehouse/batch/v2/${id}/confirm`;
    return await api.post(url, data);
  }

  async selectionV2(id, data) {
    const url = `${this.url}/api/blueberry/v1/warehouse/batch/v2/${id}/selection`;
    return await api.patch(url, data);
  }

  async confirmBatch(batchId, { action, observation }) {
    const url = `${this.url}/api/blueberry/v1/warehouse/batch/v2/${batchId}/blitz/step`;
    return await api.post(url, { action, observation });
  }

  async getBatchReason(params) {
    const url = `${this.url}/api/blueberry/v1/warehouse/batch/reason`;
    return await api.get(url, { params });
  }

  async postBatchImage(data) {
    const url = `${this.url}/api/blueberry/v1/warehouse/batch/image`;
    return await api.post(url, data);
  }
}

const batchService = new BatchService();
export default batchService;
